<div class="detail-pay" mat-dialog-content style="max-height: none">
  <div style="width: 100%; display: flex; justify-content: flex-end">
    <button mat-icon-button class="back-btn" (click)="goBack()">X</button>
  </div>
  <div class="titulo-2">
    <div class="titulo ticket-text" [innerHTML]="titulo"></div>
  </div>
  <br />
  <div>
    <div>
      <div
        class="monto"
        style="font-weight: 800; font-size: 32px"
        [ngClass]="{ in: data.monto > 0, out: data.monto < 0 }"
      >
        {{ maskPrice(monto) }}
      </div>
      <span style="font-size: 12px" [ngClass]="setClassEstado(data.estado)">{{ data.estado }}</span>
    </div>
  </div>
  <br />
  <div style="text-align: start; font-size: 12px">
    <span>{{ 'pages.detail-payment.operation-number' | translate }}{{ data.id }}</span
    ><br />
    <span
      >{{ (data.tipoMovimiento === 'IncomingTransaction' ? 'pages.detail-payment.transaction_number' : '') | translate
      }}{{ data.tipoMovimiento === 'IncomingTransaction' ? data.referencia : '' }}</span
    >
  </div>
  <div style="display: flex; text-align: start; font-size: 12px">
    <span style="margin-right: 0.2rem">{{ 'pages.detail-payment.acredit-number' | translate }}</span>
    <span [innerHTML]="data.fechaAcreditacionFormat"></span>
  </div>
  <div style="display: flex; text-align: start; font-size: 12px; flex-direction: column">
    <span
      >{{ 'pages.detail-payment.cuil-cuit' | translate
      }}{{ data.cuilCuitContraparte ? maskCuit(data.cuilCuitContraparte) : 'No especificado' }}</span
    >
    <span
      >{{ 'pages.detail-payment.cvu-cbu' | translate
      }}{{ data.cvuContraparte ? data.cvuContraparte : 'No especificado' }}</span
    >
    <span
      >{{ data.debinId?.length === 22 ? 'Debin ID: ' : '' }}{{ data.debinId?.length === 22 ? data.debinId : '' }}</span
    >
  </div>
  <br />
  <div>
    <div style="font-weight: 600">
      <span
        >{{ 'pages.detail-payment.payment-method' | translate
        }}{{ generarTitulo(data.mpTipo.descripcion, data.billetera) }}</span
      >
    </div>
  </div>
  <br />
  <div *ngIf="data.sucursal !== '-'">
    <span>{{ 'pages.detail-payment.branch' | translate }}{{ data.sucursal }}</span>
  </div>
  <div *ngIf="data.caja !== '-'">
    <span>{{ 'pages.detail-payment.cashier' | translate }}{{ data.caja }}</span>
  </div>
  <br />
  <br />
  <br />
  <div style="display: flex; justify-content: space-between">
    <div style="display: flex; flex-direction: column">
      <!-- BOTON DE ANULAR PAGOS -->
      <div *ngIf="isCommerce && evaluarMovimiento(data) && evaluarTitulo(data.titulo) && evaluarEstadoMov(data.estado)">
        <button *ngIf="!isFlipped" mat-button button="button" style="color: red" (click)="openDialog()">
          {{ 'pages.detail-pay.labels.refund' | translate }}
        </button>
      </div>
      <button mat-button style="color: #ff6600" class="ticket-btn" (click)="navigate('/user/help')">
        {{ 'pages.detail-payment.need-help' | translate }}
      </button>
    </div>
    <button
      *ngIf="data.comprobanteDisponible"
      mat-button
      style="color: #ff6600"
      class="ticket-btn"
      (click)="download()"
      [disabled]="downloadLoading"
    >
      <ng-container *ngIf="downloadLoading; else printText">
        <mat-spinner diameter="20"></mat-spinner>
      </ng-container>
      <ng-template #printText>
        {{ 'pages.detail-payment.print' | translate }}
      </ng-template>
    </button>
  </div>
</div>
